import React, { useState } from "react";
import { Zap } from "lucide-react";
import RunningTaskCard from "./RunningTaskCard";

/**
 * RunningTasksList component
 * Displays running tasks in a grid layout similar to other dashboard sections
 */
const RunningTasksList = ({ tasks = [], title = "Running Tasks", onTaskClick }) => {
  if (!tasks || tasks.length === 0) {
    return null;
  }

  return (
    <div className="bg-white dark:bg-slate-800 border-t border-gray-200 dark:border-slate-700 px-4 py-2 transition-colors duration-200">
      {/* Header with icon, title, and count */}
      <div className="flex items-center space-x-2 mb-2">
        <Zap className="w-6 h-6 text-green-600 dark:text-green-400" />
        <h2 className="text-base font-semibold dark:text-white">{title || "Running Tasks"}</h2>
        {tasks.length > 0 && (
          <span className="bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-400 text-xs font-medium px-2 py-0.5 rounded-full">
            {tasks.length}
          </span>
        )}
      </div>

      {/* Tasks Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3">
        {tasks.map((task) => (
          <RunningTaskCard
            key={task._id}
            task={task}
            onTaskClick={onTaskClick}
          />
        ))}
      </div>
    </div>
  );
};

export default RunningTasksList;
